import { useEffect, useId } from 'react';
import { clearUnsavedWork, setUnsavedWork } from '@shared/lib/unsavedWork';

/**
 * Report this form's dirty state to the shared unsaved-work registry,
 * and nothing else.
 *
 * `useUnsavedChangesSimple` already does this, so a form that uses the
 * shared guard needs neither. This exists for the forms that guard
 * themselves — the account-access form, the create wizards, the
 * feedback dialog — which keep their own "discard changes?" dialog and
 * were therefore invisible to the registry. The mandatory-update screen
 * asks the registry before it replaces the app, so being invisible
 * meant losing whatever was typed.
 *
 * Takes the boolean the form already computes; it does not interfere
 * with navigation, which those forms handle in their own way.
 */
export const useReportUnsavedWork = isDirty => {
  const sourceId = useId();

  useEffect(() => {
    setUnsavedWork(sourceId, !!isDirty);
  }, [sourceId, isDirty]);

  // Separate from the line above so unmount always clears, whatever the
  // last reported value was.
  useEffect(() => () => clearUnsavedWork(sourceId), [sourceId]);
};

export default useReportUnsavedWork;
